import React from "react";
import { useSelector } from "react-redux";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const Forecast = () => {
  const {
    forecast,
    currencySymbol,
    forecastTooltip = "",
    forecastChange
  } = useSelector((state) => state.totalRevenue.allRevenues);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <MoneyDisplay
        value={forecast}
        currency={currencySymbol}
        size={44}
        disableAnimation={isUserQa}
        toolTip={forecastTooltip}
        toolTipId="revenueDetailsForecast"
      />
      <PercentChanged
        changeValue={forecastChange}
        toolTip="Percentage change from previous month"
        showBorder
      />
    </>
  );
};

export default Forecast;
